import React, { useState } from 'react'
import { Steps } from 'antd'
import ProfileDetails from './ProfileDetails'
import OrganizationDetails from './OrganizationDetails'
import LegalInformationPage from './LegalInformationPage'
import FranchiseAgreement from './FranchiseAgreement'

interface IProps {
  isOffsetLimit: any
}

const { Step } = Steps

const OnboardingForm: React.FC<IProps> = ({ isOffsetLimit }) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [formData, setFormData] = useState({
    organization: '',
    location: null,
    id: '',
    companySize: '',
    industry: '',
    logo: null,
    registeredAddress: '',
    typeOfCompany: '',
    dateOfIncorporation: '',
    businessContactNumber: '',
    CIN: '',
    PAN: '',
    TAN: '',
    GSTIN: ''
  })
  const [userDetails, setUserDetails] = useState({
    Fullname: '',
    Email: '',
    ContactNumber: '',
    Designation: ''
  })

  const nextStep = () => {
    setCurrentStep(currentStep + 1)
  }

  const prevStep = () => {
    setCurrentStep(currentStep - 1)
  }

  const steps = [
    {
      title: 'Profile Details',
      content: (
        <ProfileDetails
          nextStep={nextStep}
          formData={formData}
          setFormData={setFormData}
          userDetails={userDetails}
          setUserDetails={setUserDetails}
        />
      )
    },
    {
      title: 'Organization Details',
      content: (
        <OrganizationDetails
          nextStep={nextStep}
          prevStep={prevStep}
          formData={formData}
          setFormData={setFormData}
        />
      )
    },
    {
      content: (
        <LegalInformationPage
          nextStep={nextStep}
          prevStep={prevStep}
          formData={formData}
          setFormData={setFormData}
        />
      ),
      title: 'Legal Information'
    },
    {
      content: (
        <FranchiseAgreement
          nextStep={nextStep}
          prevStep={prevStep}
          formData={formData}
          setFormData={setFormData}
          isOffsetLimit={isOffsetLimit}
        />
      ),
      title: 'Franchise Agreement'
    }
  ]

  return (
    <div className='card'>
      <h1 className='d-flex align-item-center justify-content-center m-10'>Onboarding Form</h1>
      <div
        className='card-header border-0 cursor-pointer justify-content-center' // Center-align the header content
      >
        <div className='card-title align-center w-100'>
          <Steps current={currentStep}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} className='m-1' />
            ))}
          </Steps>
        </div>
      </div>

      <div className='steps-content'>{steps[currentStep].content}</div>
    </div>
  )
}

export default OnboardingForm
